import Vue from 'vue'
import Vuex from 'vuex'
import files from './modules/files'
import applications from './modules/applications'
import programs from './modules/programs'
import applicationRegistration from '@/store/modules/applicationRegistration'
import paymentPortal from '@/store/modules/paymentPortal'
import family from '@/store/modules/family'
import alertMessage from '@/store/modules/alertMessage'
import authSettings from '@/store/modules/authSettings'
import paymentSettings from '@/store/modules/paymentSettings'
import registration from '@/store/modules/registration'
import addNewChild from '@/store/modules/addNewChild'
import children from '@/store/modules/children'
import forms from '@/store/modules/forms'
import preRegistrationForm from '@/store/modules/preRegistrationForm'
import formValidation from '@/store/modules/formValidation'
import cards from '@/store/modules/cards'
import productCatalog from '@/store/modules/productCatalog'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    files,
    applications,
    programs,
    applicationRegistration,
    paymentPortal,
    family,
    alertMessage,
    authSettings,
    paymentSettings,
    registration,
    addNewChild,
    children,
    forms,
    preRegistrationForm,
    formValidation,
    cards,
    productCatalog,
  },
  state: {
    isAuthorized: false,
    loggedAsUser: false,
    loading: false,
    userData: JSON.parse(localStorage.getItem('userData')) || null,
  },
  mutations: {
    CHANGE_USER_STATUS(state, val) {
      state.isAuthorized = val
    },
    CHANGE_ADMIN_USER_STATUS(state, val) {
      state.loggedAsUser = val
    },
    SET_LOADING_STATUS(state, val) {
      state.loading = val
    },
    SET_USER_DATA(state, val) {
      state.userData = val
    },
    SET_REQUIRE_RESET_PASSWORD(state, value) {
      if (!state.userData) return

      state.userData = {
        ...state.userData,
        require_reset_password: value,
      }

      localStorage.setItem('userData', JSON.stringify(state.userData))
    },
  },
  actions: {
    setUserStatus(commit, val) {
      commit('CHANGE_USER_STATUS', val)
    },
    setAsUserStatus(commit, val) {
      commit('CHANGE_ADMIN_USER_STATUS', val)
    },
  },
  getters: {
    getASUserStatus: state => state.loggedAsUser,
    getUserStatus: state => state.isAuthorized,
    getLoadingStatus: state => state.loading,
    getUserData: state => state.userData,
    getUserRole: state => state.userData?.role,
  },
})
